import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useEnrollmentActions } from '@sayyesschool/frontend/features/enrollments';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import EnrollmentForm from '@/components/enrollments/enrollment-form';
import EnrollmentsList from '@/components/enrollments/enrollments-list';

export default function LearnerEnrollments({ learner, manager }) {
    const navigate = useNavigate();
    const enrollmentActions = useEnrollmentActions();

    const [isEnrollmentFormOpen, toggleEnrollmentFormOpen] = useBoolean(false);

    const createEnrollment = useCallback(data => {
        return enrollmentActions.createEnrollment(data)
            .then(({ data }) => navigate(`/learners/${learner?.id}/enrollments/${data?.id}`));
    }, [learner, enrollmentActions, navigate]);

    const enrollments = learner?.enrollments.map(enrollment => ({ ...enrollment, url: `${learner.url}${enrollment.url}` }));

    return (
        <PageSection
            className="LearnerEnrollments"
            title="Обучение"
            actions={[
                {
                    key: 'add',
                    icon: 'add',
                    title: 'Создать обучение',
                    onClick: toggleEnrollmentFormOpen
                }
            ]}
            compact
        >
            {enrollments.length > 0 &&
                <EnrollmentsList enrollments={enrollments} />
            }

            <FormDialog
                form="enrollment-form"
                title="Новое обучение"
                open={isEnrollmentFormOpen}
                onClose={toggleEnrollmentFormOpen}
            >
                <EnrollmentForm
                    id="enrollment-form"
                    enrollment={{
                        learnerId: learner.id,
                        managerId: manager.id
                    }}
                    onSubmit={createEnrollment}
                />
            </FormDialog>
        </PageSection>
    );
}